<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="exportForm">
		<div *ngIf="loading">
			<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<!-- ROW * -->
		<div class="grid" *ngIf="!loading">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.Metrics, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Metrics, 'label')">{{ 'METRICS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.Metrics, 'borderInput')">
						<p-multiSelect formControlName="Metrics" [options]="listMetrics" appendTo="body"
							[ngClass]="dynamicInputTextWidthMultiselect()" [styleClass]="dynamicInputTextWidthMultiselect()"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
							<ng-template let-metrics pTemplate="selectedItems">
								<span *ngFor="let metric of metrics;">
									<span class="font-medium text-0">{{ metric.Name | translate }}, </span>
								</span>
							</ng-template>
							<ng-template let-metrictem pTemplate="item">
								<div class="item">
									<div>{{ metrictem.Name | translate }}</div>
								</div>
							</ng-template>
						</p-multiSelect>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.Metrics)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="startDate" appendTo="body"
							placeholder="dd/mm/yyyy" [minDate]="minDate" [defaultDate]="today" dateFormat="dd/mm/yy"
							[ngClass]="dynamicInputShortTextWidth()" [styleClass]="dynamicInputShortTextWidth()"
							inputStyleClass="pl-6 sm:pl-5 border-noround-right" panelStyleClass="{{ dynamicDatepicker() }}">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.startTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.startTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="startTime" appendTo="body"
							timeOnly="true" [ngClass]="dynamicInputShortTextWidth()"
							[styleClass]="dynamicInputShortTextWidth()" inputStyleClass="pl-6 sm:pl-5 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.startTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="endDate" appendTo="body"
							placeholder="dd/mm/yyyy" [minDate]="exportForm.value.startDate" [defaultDate]="today"
							dateFormat="dd/mm/yy" [ngClass]="dynamicInputShortTextWidth()"
							[styleClass]="dynamicInputShortTextWidth()" inputStyleClass="pl-6 sm:pl-5 border-noround-right"
							panelStyleClass="{{ dynamicDatepicker() }}">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endTime, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.endTime, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon" formControlName="endTime" appendTo="body" timeOnly="true"
							[ngClass]="dynamicInputShortTextWidth()" [styleClass]="dynamicInputShortTextWidth()"
							inputStyleClass="pl-6 sm:pl-5 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.endTime)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>